<template>
    <WelcomeCreditsDialog
        v-if="welcomeCredits.visible.value"
        v-model:visible="welcomeCredits.visible.value"
        :creditsAmount="welcomeCredits.creditsAmount.value"
        @close="welcomeCredits.closeDialog"
        @claimCredits="welcomeCredits.claimCredits"
    />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import psHttp from '@patsnap/common-ps-http';
import { WelcomeCreditsDialog, useWelcomeCredits } from 'patsnap-biz';
import '@patsnap-biz/welcome-credits-dialog/lib/style';
import { EUREKA_SERVICE_URI } from '@telecom/shared/domain-config/config';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { getIsOversea } from '@telecom/shared/utils/environment';

type WelcomeCreditsLocale = 'cn' | 'en' | 'jp' | 'tw';

const { locale } = useI18n();

const welcomeCredits = useWelcomeCredits({
    baseURL: EUREKA_SERVICE_URI,
    http: psHttp,
    locale: locale.value as WelcomeCreditsLocale,
});

onMounted(async () => {
    const isLogin = await isUserLogin();
    if (!isLogin) return;
    if (!getIsOversea()) return;

    welcomeCredits.checkWelcomeCredits();
});
</script>
